<template>
  <div class="image-text">
    <slot name="image"></slot>
    <slot name="text"></slot>
  </div>
</template>

<script>
export default {
  name: "ImageTextBottomLeft",
};
</script>

<style lang="scss" scoped>
.image-text {
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
</style>
